var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearNight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "var(--color--primary-text)"
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "weather-night-clear") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.687,14.934A8.5,8.5,0,0,1,10.125,6.5a8.573,8.573,0,0,1,.28-2.171A1,1,0,0,0,9.314,3.082a10.5,10.5,0,1,0,11.464,13.1,1,1,0,0,0-1.091-1.247ZM10.625,22a8.5,8.5,0,0,1-2.8-16.526.249.249,0,0,1,.332.254q-.028.386-.028.772A10.514,10.514,0,0,0,18,16.982a.249.249,0,0,1,.208.362A8.508,8.508,0,0,1,10.625,22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.445,10.505l-.264-.038a1.508,1.508,0,0,1-1.273-1.273l-.038-.265a.5.5,0,0,0-.99,0l-.038.265a1.508,1.508,0,0,1-1.273,1.273l-.264.038a.5.5,0,0,0,0,.99l.264.038a1.508,1.508,0,0,1,1.273,1.273l.038.265a.5.5,0,0,0,.99,0l.038-.265a1.508,1.508,0,0,1,1.273-1.273l.264-.038a.5.5,0,0,0,0-.99Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.305,4.5l.464.066a3.013,3.013,0,0,1,2.544,2.546l.067.463a.5.5,0,0,0,.99,0l.067-.464a3.013,3.013,0,0,1,2.544-2.545l.464-.066a.5.5,0,0,0,0-.99l-.464-.066A3.013,3.013,0,0,1,17.437.893L17.37.43a.5.5,0,0,0-.99,0l-.067.464a3.013,3.013,0,0,1-2.544,2.545l-.464.066a.5.5,0,0,0,0,.99Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearNight);
export default __webpack_public_path__ + "static/media/clear_night.0ff98d435d154a48b0e5b383834249a8.svg";
export { ForwardRef as ReactComponent };